export const IMMEDIATE_NURSE_CONSULT_TRACKING_ID = 'immediateNurseConsultTrackingPayload';

export const IMMEDIATE_NURSE_CONSULT_SMS_LOCAL_STORAGE_KEY = 'immediateNurseConsultSmsVerification';

export const MAX_SMS_RETRY_AFTER_MS = 240_000;

export const MAX_SMS_RETRY_COUNT = 4;
